import { useCallback, useEffect, useRef, useState } from 'react';

import { secondsUntil } from '#src/lib/date-fns';

export const useCountdown = (toDate, onZero) => {
  const [secondsRemaining, setSecondsRemaining] = useState(
    Math.max(secondsUntil(toDate), 0)
  );
  const intervalEl = useRef(null);

  const stopCounter = () => {
    if (intervalEl.current) clearInterval(intervalEl.current);
  };

  const setLeadingZero = (value) => value.toString().padStart(2, '0');

  const decrementCounter = useCallback(() => {
    const nextSecs = secondsRemaining > 0 ? secondsRemaining - 1 : 0;
    if (nextSecs == 0) {
      stopCounter();
      onZero && onZero();
    }
    setSecondsRemaining(nextSecs);
  }, [onZero, secondsRemaining]);

  useEffect(() => {
    intervalEl.current = setInterval(decrementCounter, 1000);
    return () => {
      stopCounter();
      intervalEl.current = null;
    };
  }, [decrementCounter, toDate]);

  return secondsRemaining > 0
    ? {
        seconds: setLeadingZero(secondsRemaining % 60),
        minutes: parseInt(secondsRemaining / 60, 10) % 60,
        hours: parseInt(secondsRemaining / (60 * 60), 10) % 24,
        days: parseInt(secondsRemaining / (60 * 60 * 24), 10),
      }
    : null;
};
